import api from "../../../utils/api";
import { setAlert } from "../alert";
import { handleError } from "../errors";
import { BULK_SUB_CLIENT_DELETE_PROJECT, BULK_SUB_CLIENT_DELETE_PROJECT_ERROR, BULK_UPDATE_SUB_CLIENT_PROJECT_STATUS, BULK_UPDATE_SUB_CLIENT_PROJECT_STATUS_ERROR, GET_CLIENT_PROJECT_BY_REFNUM, GET_CLIENT_PROJECT_BY_REFNUM_ERROR, GET_SUB_CLIENT_PROJECT_LIST, GET_SUB_CLIENT_PROJECT_LIST_ERROR, GET_SUB_PROJECT_LIST, GET_SUB_PROJECT_LIST_ERROR, GET_SUB_PROJECT_STATUS_LIST, GET_SUB_PROJECT_STATUS_LIST_ERROR, RESET_CLIENT_PROJECT_DETAILS, RESET_CLIENT_PROJECT_LIST, SAVE_CLIENT_PROJECT, SAVE_CLIENT_PROJECT_ERROR, SET_CLIENT_PROJECT_BULK_UPDATE } from "../types";

export const get_sub_client_project_list = (projectName, clientName, status) => async (dispatch) => {
    try {
        const res = await api.get(`api/sub-project/get-cli-project-list`,
            {
                params: {
                    projectName: projectName,
                    clientName: clientName,
                    status: status,
                }
            }
        );
        dispatch({
            type: GET_SUB_CLIENT_PROJECT_LIST,
            payload: res.data,
        });
    } catch (err) {
        handleError(err, dispatch);
        dispatch({
            type: GET_SUB_CLIENT_PROJECT_LIST_ERROR,
        });
    }
};

export const get_sub_project_status_list = () => async (dispatch) => {
    try {
        const res = await api.get(`api/sub-project/get-cli-project-status-list`);
        dispatch({
            type: GET_SUB_PROJECT_STATUS_LIST,
            payload: res.data,
        });
    } catch (err) {
        handleError(err, dispatch);
        dispatch({
            type: GET_SUB_PROJECT_STATUS_LIST_ERROR,
        });
    }
};

export const bulk_sub_client_delete_project = (bulkData) => async (dispatch) => {
    try {
        const res = await api.post(`api/sub-project/bulk-delete-cli-project`, bulkData)
        dispatch({
            type: BULK_SUB_CLIENT_DELETE_PROJECT,
            payload: true
        })
        dispatch(setAlert(res.data.message, 'success'))
        return true;
    } catch (err) {
        handleError(err, dispatch);
        dispatch({
            type: BULK_SUB_CLIENT_DELETE_PROJECT_ERROR
        })
        return false;
    }
}

export const bulk_update_sub_client_project_status = (bulkData) => async (dispatch) => {
    try {
        const res = await api.post(`api/sub-project/bulk-update-cli-project-status`, bulkData)
        dispatch({
            type: BULK_UPDATE_SUB_CLIENT_PROJECT_STATUS,
            payload: true
        })
        dispatch(setAlert(res.data.message, 'success'))
        return true;
    } catch (err) {
        handleError(err, dispatch);
        dispatch({
            type: BULK_UPDATE_SUB_CLIENT_PROJECT_STATUS_ERROR
        })
        return false;
    }
}

export const reset_client_project_list = () => (dispatch) => dispatch({ type : RESET_CLIENT_PROJECT_LIST });
export const set_client_project_bulk_update = () => (dispatch) => dispatch({ type: SET_CLIENT_PROJECT_BULK_UPDATE })

export const save_subscriber_client_project = (project) => async (dispatch) => {
    try {
        const res = await api.post('api/sub-project/save-cli-project', project);
        dispatch(setAlert(res.data.message, 'success'))
        dispatch({
            type: SAVE_CLIENT_PROJECT,
            payload: res.data
        })
        return true;
    } catch (err) {
        handleError(err, dispatch);
        dispatch({ type: SAVE_CLIENT_PROJECT_ERROR })

        return false;
    }
}

export const get_client_project_by_refnum = (refNum) => async (dispatch) => {
    try {
        const res = await api.get(`api/sub-project/get-cli-project?projectRefNum=${refNum}`);
        dispatch({
            type: GET_CLIENT_PROJECT_BY_REFNUM,
            payload: res.data
        })
    } catch (err) {
        handleError(err, dispatch);
        dispatch({
            type: GET_CLIENT_PROJECT_BY_REFNUM_ERROR,
        });
    }
}

export const reset_client_project_details = () => (dispatch) => dispatch({ type : RESET_CLIENT_PROJECT_DETAILS });

//For timesheet
export const get_sub_project_list = (name) => async (dispatch) => {
    try {
        const res = await api.get(`api/sub-project/project-list?clientId=${name}`);
        dispatch({
            type: GET_SUB_PROJECT_LIST,
            payload: res.data,
        });
    } catch (err) {
        handleError(err, dispatch);
        dispatch({
            type: GET_SUB_PROJECT_LIST_ERROR,
        });
    }
};
